import { Link, Navigate, useParams } from "react-router-dom";
import Seo from "../Seo";
import L from "../../constants/baysportLabels";
import { getLegalDocument } from "../../constants/legalDocuments";
import { LEGAL_PATHS, LEGAL_PUBLIC_ENABLED } from "../../constants/legalPaths";
import { LegalDocLink } from "./LegalDocLink";
import s from "./legalPage.module.css";

const DOC_BY_SLUG = {
  offer: "offer",
  privacy: "privacy",
  cookies: "cookies",
  payments: "payments",
  "client-consent": "clientConsent",
  "owner-consent": "ownerConsent",
};

export default function LegalPage() {
  const { docSlug } = useParams();

  if (!LEGAL_PUBLIC_ENABLED) {
    return <Navigate to="/" replace />;
  }

  const docId = DOC_BY_SLUG[docSlug];
  const doc = docId ? getLegalDocument(docId) : null;

  if (!doc) {
    return <Navigate to={LEGAL_PATHS.offer} replace />;
  }

  return (
    <div className={s.page}>
      <Seo title={doc.title} description={doc.description} />
      <header className={s.header}>
        <Link to="/" className={s.brand}>
          {L.productName}
        </Link>
        <nav className={s.nav} aria-label="Документы">
          <LegalDocLink
            doc="offer"
            className={docId === "offer" ? s.navActive : undefined}
          >
            Оферта
          </LegalDocLink>
          <LegalDocLink
            doc="privacy"
            className={docId === "privacy" ? s.navActive : undefined}
          >
            Конфиденциальность
          </LegalDocLink>
          <LegalDocLink
            doc="cookies"
            className={docId === "cookies" ? s.navActive : undefined}
          >
            Cookies
          </LegalDocLink>
          <LegalDocLink
            doc="payments"
            className={docId === "payments" ? s.navActive : undefined}
          >
            Платежи
          </LegalDocLink>
          <LegalDocLink
            doc="clientConsent"
            className={docId === "clientConsent" ? s.navActive : undefined}
          >
            Согласие клиента
          </LegalDocLink>
          <LegalDocLink
            doc="ownerConsent"
            className={docId === "ownerConsent" ? s.navActive : undefined}
          >
            Согласие владельца
          </LegalDocLink>
        </nav>
      </header>

      <main className={s.main}>
        <p className={s.updated}>Редакция от {doc.updatedAt}</p>
        <h1 className={s.title}>{doc.title}</h1>
        {doc.sections.map((section) => (
          <section key={section.heading} className={s.section}>
            <h2 className={s.heading}>{section.heading}</h2>
            {section.paragraphs.map((text, i) => (
              <p key={`${section.heading}-${i}`} className={s.p}>
                {text}
              </p>
            ))}
          </section>
        ))}
      </main>

      <footer className={s.footer}>
        <Link to="/">← На главную</Link>
      </footer>
    </div>
  );
}
